import { useState, useEffect, RefObject } from 'react';

interface UseContainerSizeResult {
  containerRect: DOMRect | null;
  isLongContainer: boolean;
}

const useContainerSize = (containerRef?: RefObject<HTMLElement>): UseContainerSizeResult => {
  const [containerRect, setContainerRect] = useState<DOMRect | null>(null);
  const [isLongContainer, setIsLongContainer] = useState(false);

  useEffect(() => {
    const scrollElement = containerRef?.current || document.documentElement;

    if (!scrollElement) return;

    const updateMeasurements = () => {
      const rect = containerRef?.current?.getBoundingClientRect() || null;
      const viewportHeight = containerRef?.current?.clientHeight || window.innerHeight;

      setContainerRect(rect);
      setIsLongContainer(scrollElement.scrollHeight > viewportHeight * 2);
    };

    const resizeObserver = new ResizeObserver(updateMeasurements);

    resizeObserver.observe(scrollElement);
    window.addEventListener('resize', updateMeasurements);

    updateMeasurements();

    return () => {
      resizeObserver.disconnect();

      window.removeEventListener('resize', updateMeasurements);
    };
  }, [containerRef]);

  return { containerRect, isLongContainer };
};

export default useContainerSize;
